// A small, static patch drawn by the store's existing moss engine.
class CartMoss04 extends HTMLElement {
  connectedCallback() {
    this.canvas = document.createElement('canvas');
    this.append(this.canvas);
    this.observer = new ResizeObserver(this.paint);
    this.observer.observe(this);
    window.addEventListener('load', this.paint);
    document.addEventListener('shopify:section:load', this.paint);
    this.paint();
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    window.removeEventListener('load', this.paint);
    document.removeEventListener('shopify:section:load', this.paint);
  }
  paint = () => {
    const engine = window.Moss04Engine;
    if (!engine?.Layer || !this.clientWidth || !this.clientHeight) return;
    const size = `${this.clientWidth}:${this.clientHeight}`;
    if (this.paintedSize === size) return;
    this.layer = new engine.Layer(this, {
      canvas: this.canvas,
      lut: engine.makeLUT(engine.DEF),
      size: 1.1,
      dir: 'up',
      anchor: 'top',
      height: (height) => height,
      profile: (t) => 0.45 + 0.55 * engine.ss(0, 1, t),
    });
    this.layer.build();
    this.layer.paint(1, null);
    this.paintedSize = size;
  };
}
if (!customElements.get('cart-moss-04')) customElements.define('cart-moss-04', CartMoss04);

const attachMoss = () => {
  document.querySelectorAll('#cart-drawer .theme-drawer__dialog, .cart-page').forEach((host) => {
    if (host.querySelector(':scope > cart-moss-04')) return;
    const moss = document.createElement('cart-moss-04');
    moss.setAttribute('aria-hidden', 'true');
    host.prepend(moss);
  });
};
attachMoss();
let frame;
new MutationObserver(() => {
  cancelAnimationFrame(frame);
  frame = requestAnimationFrame(attachMoss);
}).observe(document.body, { childList: true, subtree: true });
